var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.3C9.50654 3.3 3.27273 8.79607 3.27273 14.85C3.27273 17.7483 4.64824 20.4614 7.04874 22.5571C7.46949 22.9245 7.67624 23.4822 7.59757 24.0378L6.97048 28.466L12.0711 25.8944C12.4288 25.7141 12.8395 25.672 13.2258 25.7762C14.7205 26.1795 16.326 26.4 18 26.4C26.4935 26.4 32.7273 20.9039 32.7273 14.85C32.7273 8.79607 26.4935 3.3 18 3.3ZM0 14.85C0 6.32452 8.41818 0 18 0C27.5818 0 36 6.32452 36 14.85C36 23.3755 27.5818 29.7 18 29.7C16.2653 29.7 14.5847 29.4977 12.9924 29.1194L5.64089 32.8258C5.09653 33.1003 4.44608 33.0474 3.95233 32.6886C3.45859 32.3298 3.20312 31.7243 3.28916 31.1167L4.23575 24.4324C1.63317 21.8888 0 18.5562 0 14.85Z",
    fill: "url(#paint0_linear_79_1653)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_1653",
    x1: 0,
    y1: 16.5,
    x2: 36,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDCD86"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.670f2b64ed576cf793f324d5981d6749.svg";
export { ForwardRef as ReactComponent };